<template>
    <div>
        <van-popup overlay round v-model="isShowPopup" position="bottom" :style="styleObj" class="cu-popup">
            <div class="popup-title">
                {{ title }}
                <van-icon name="cross" @click="isShowPopup = false" />
            </div>
            <div class="popup-content">
                <slot name="content"></slot>
            </div>
            <div class="popup-btn-wrap">
                <slot name="btns"><van-button round @click="confirm()">{{ btnText }}</van-button></slot>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { Button, Icon, Popup } from 'vant'

export default {
    name: 'CuPopup',
    components: {
        vanIcon: Icon,
        VanButton: Button,
        VanPopup: Popup,
    },
    props: {
        styleObj: {
            type: Object,
            default: () => {
                return { height: '50%' }
            },
        },
        title: {
            type: String,
            default: '',
        },
        btnText: {
            type: String,
            default: '确认',
        },
    },

    data() {
        return {
            isShowPopup: false,
        }
    },

    methods: {
        close() {
            this.$emit('close')
            this.isShowPopup = false
        },
        open() {
            this.isShowPopup = true
        },
        confirm() {
            this.$emit('confirm')
            this.isShowPopup = false
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/variableName.scss';
@import '../../../style/mixin';
.cu-popup {
    padding-bottom: torem(20);
    .popup-title {
        display: flex;
        justify-content: space-between;
        padding: torem(24) torem(16) torem(16);
        color: rgba(0, 0, 0, 0.85);
        font-size: torem(16);
        font-weight: Bold;
        @include sc(torem(18), #333);
        /deep/ .van-icon {
            font-size: torem(20);
        }
    }
    .popup-content {
        padding: torem(16);
        /deep/ .van-cell-group {
            margin-top: torem(12);
            margin-bottom: torem(12);
        }
        /deep/ .van-cell {
            padding-left: 0;
        }
        /deep/ .van-cell__title {
            overflow: hidden;
            display: flex;
            align-items: center;
            // margin-right: torem(57);
        }
        /deep/ .van-cell__title span {
            max-width: torem(250);
            word-break: normal;
            width: auto;
            display: block;
            white-space: pre-wrap;
            word-wrap: break-word;
        }
        /deep/ .van-icon-success {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        /deep/ .van-icon {
            font-size: torem(20);
        }
    }
    .popup-btn-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        /deep/ .van-button {
            width: torem(343);
            height: torem(48.5);
            font-size: torem(14);
            margin: 0 auto;
            color: #fff;
            border-radius: torem(20);
            background-color: rgba(38, 38, 38, 1);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/InscriptionArea/compontents/cuPopup.vue